import { IotError } from "@iot-platform/core";
import { t } from "i18next";

export class InternalInvalidSessionUserError extends IotError {
    constructor() {
        super(t("error:authentication.internal.invalidSessionUser"));

        Object.setPrototypeOf(this, InternalInvalidSessionUserError.prototype);
    }
}
